/* __next_internal_client_entry_do_not_use__ PaginationFooter auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import * as React from "react";
import { Spacer } from "../spacing";
import { Pagination } from "./Pagination";
import { FooterWrapper } from "./styles";
export var PaginationFooter = function(props) {
    return /*#__PURE__*/ _jsxs(FooterWrapper, {
        children: [
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(Pagination, _object_spread({}, props)),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsx(HorizontalLine, {})
        ]
    });
};
